<template>
  <div class="page-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-sticky>
        <div class="page-top">
          <SearchBar
            @search="search"
            @focus="isShowBottomBtn = false"
            @blur="isShowBottomBtn = true"
            v-model="searchVal"
            :has-search-btn="true"
            placeholder="请输入名称/ID/电话查询"
          />
          <div class="reg-time-box">
            <div class="reg-time-label">注册时间</div>
            <DateRangePicker
              :days="0"
              :hasClear="true"
              :width="128"
              :hasFastSelect="false"
              @search="setTime"
              class="date-range-picker"
            />
          </div>
        </div>
      </van-sticky>
      <div class="list-wrp">
        <div class="list-box">
          <van-list
            :immediate-check="false"
            v-model:loading="loading"
            :finished="finished"
            :finished-text="finishedText"
            @load="getList"
          >
            <div class="list-item-wrp" v-for="item in list" :key="item.puid">
              <div class="base-info">
                <div class="content-name">
                  <van-image
                    :width="transPxToRem(32)"
                    :height="transPxToRem(32)"
                    round
                    :src="item.avatarUrl || 'https://x.jzbull.com/x_dsx_wxapp/icons/default-head.png'"
                  />
                  <div class="nickname-wrp">
                    <div class="nickname" v-if="item.nickname">{{ item.nickname }}</div>
                    <div class="user-tag">注册用户</div>
                  </div>
                </div>
                <div class="content-info">
                  <div
                    class="content-info-item"
                    v-for="sItem in [
                      { label: '个人ID', key: 'puid' },
                      { label: '手机号', key: 'mobile' },
                      { label: '注册时间', key: 'createdTime' }
                    ]"
                    :key="sItem.key"
                  >
                    <div class="label">{{ sItem.label }}</div>
                    <div class="value">{{ item[sItem.key] }}</div>
                  </div>
                </div>
              </div>
              <van-divider />
              <van-row>
                <van-col
                  span="12"
                  class="order-num-box"
                  v-for="sItem in [
                    { label: '下单数(单)', key: 'orderCount' },
                    { label: '下单金额(元)', key: 'orderAmount' }
                  ]"
                  :key="sItem.key"
                >
                  <div>
                    <template v-if="sItem.key === 'orderAmount' && item[sItem.key] > 0">¥</template>
                    {{ item[sItem.key] }}
                  </div>
                  <div class="label">{{ sItem.label }}</div>
                </van-col>
              </van-row>
            </div>
          </van-list>
          <!-- <van-empty
            image-size="60"
            image="https://x.jzbull.com/x_dsx_h5admin/icons/empty.png"
            v-if="list.length == 0 && !loading"
            description="暂无数据"
          >
          </van-empty> -->
        </div>
        <back-top />
      </div>
    </van-pull-refresh>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, reactive } from 'vue'
// import useTime from '@/utils/time'
// import { useCssVar } from '@vueuse/core'
// import { useRouter } from 'vue-router'
// import { useToggle } from '@vant/use'
import { transPxToRem } from '@/utils'
import { getMyFansList } from '@/api/myFans'
import { BackTop, SearchBar, DateRangePicker } from '@/components'
// import RoleTag from '@/components/RoleTag'
// import { useUserStore } from '@/store/user'
// import { getLocal } from '@/common/js/utils'

const pageParams = reactive({
  page: 1,
  pageSize: 20
})

const postListParams = reactive({
  startTime: '',
  endTime: ''
})

const searchVal = ref('')
const isShowBottomBtn = ref(true)

const refreshing = ref(false)
const loading = ref(false)
const finished = ref(false)
const list = ref([])

const isFistLoadList = ref(true)

const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))

const reset = () => {
  pageParams.page = 1
  list.value = []
  finished.value = false
}

const search = () => {
  reset()
  getList()
}

const setTime = ({ startDate, endDate }) => {
  postListParams.startTime = startDate
  postListParams.endTime = endDate
  if (isFistLoadList.value) {
    return false
  }
  search()
}

const getList = async () => {
  try {
    const params = {
      keyword: searchVal.value,
      startDate: postListParams.startTime,
      endDate: postListParams.endTime,
      ...pageParams
    }
    loading.value = true
    const resData = await getMyFansList(params)
    const resList = resData.list
    list.value.push(...resList)
    pageParams.page++
    finished.value = list.value.length === Number(resData.total)
  } catch (e) {
    finished.value = true
    // console.log(e)
  } finally {
    isFistLoadList.value = false
    loading.value = false
  }
}

const onRefresh = async () => {
  refreshing.value = true
  try {
    search()
  } finally {
    refreshing.value = false
  }
}

// const userStore = useUserStore()
// const primaryColor = useCssVar('--van-primary-color', document.documentElement)
// const theme = computed(() => userStore.getTheme)

onMounted(() => {
  getList()
  // primaryColor.value = theme.value.PrimaryButtonColor
})
</script>
<style lang="less" scoped>
.page-top {
  padding-top: 12px;
  background-color: #fff;
  .reg-time-box {
    padding: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .reg-time-label {
      font-size: 14px;
    }
    // .date-range-picker {
    //   :deep(.form-item-wrp) {
    //     padding: 0 5px;
    //   }
    //   // width: auto;
    // }
  }
}
.list-wrp {
  // padding: 12px;
  // margin-top: 8px;
  border-radius: 12px 12px 0px 0px;
  // background-color: var(--van-white);
  font-size: 14px;
  .list-title {
    padding: 0 8px;
    margin-bottom: 13px;
    text-align: center;
    color: var(--van-black-6);
  }
  .list-box {
    // padding-top: 10px;
    padding-bottom: 60px;
    .list-item-wrp {
      margin: 12px;
      padding: 16px;
      border-radius: 8px;
      background-color: #fff;
      .base-info {
        // display: flex;
        .content-name {
          display: flex;
          align-items: center;
          .nickname-wrp {
            display: flex;
            align-items: center;
            margin-left: 8px;
            .nickname {
              font-size: 16px;
              font-weight: 500;
              margin-right: 8px;
            }
            .user-tag {
              width: 52px;
              height: 16px;
              line-height: 16px;
              border-radius: 2px;
              border: 1px solid #ff6060;
              color: #ff6060;
              font-size: 10px;
              text-align: center;
            }
          }
        }

        // .content {
        //   margin-left: 8px;
        .content-info {
          margin: 8px 0;
          margin-left: 40px;
          .content-info-item {
            display: flex;
            margin-bottom: 3px;
            .label {
              width: 80px;
              color: #999;
            }
          }
        }
        // }
      }
      .order-num-box {
        text-align: center;
        .label {
          font-size: 12px;
          color: #999;
          margin-top: 8px;
        }
      }
      + .list-item-wrp {
        margin-top: 12px;
      }
    }
  }
}
</style>
